import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import {
  ChassisHeightForm,
  ChassisHeightListResponse,
} from "../types";
import {
  selectChassisHeightForm,
  selectChassisHeightPage,
  selectChassisHeightPerPage,
} from "./selector";
import { chassisHeightActions } from "./slice";

let isFetchingList = false;

export function* handleGetChassisHeightList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectChassisHeightPage);
    const perPage: number = yield select(selectChassisHeightPerPage);

    const response: ChassisHeightListResponse = yield call(
      request,
      `${API_URL}/chassis-height/list?page=${page}&perPage=${perPage}`,
      { method: "GET" },
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(chassisHeightActions.getChassisHeightListSuccess(payload));
    } else {
      yield put(chassisHeightActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectChassisHeightPage);

    if (page === 1) {
      yield put(chassisHeightActions.getChassisHeightListError(message));
    } else {
      yield put(chassisHeightActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddChassisHeight() {
  const form: ChassisHeightForm = yield select(selectChassisHeightForm);

  try {
    yield call(request, `${API_URL}/chassis-height`, {
      method: "POST",
      body: JSON.stringify({
        manufacturerId: Number(form.manufacturer),
        modelId: Number(form.masterModel),
        hangerType: form.suspensionType.trim(),
        weelBase: Number(form.axleDistance),
        tire: form.tire.trim(),
        height: Number(form.net),
        year: Number(form.year),
        heightIncludeBox: Number(form.chassisHeightIncludingBody),
      }),
    });

    yield put(chassisHeightActions.addChassisHeightSuccess());
    yield put(chassisHeightActions.getChassisHeightList());
  } catch (error) {
    yield put(
      chassisHeightActions.addChassisHeightError((error as Error).message),
    );
  }
}

export function* chassisHeightSaga() {
  yield takeLeading(
    chassisHeightActions.getChassisHeightList.type,
    handleGetChassisHeightList,
  );
  yield takeLeading(
    chassisHeightActions.getNextPageItems.type,
    handleGetChassisHeightList,
  );
  yield takeLatest(
    chassisHeightActions.addChassisHeight.type,
    handleAddChassisHeight,
  );
}

export default chassisHeightSaga;
